import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-tarif.png'


const _withScopeId = n => (_pushScopeId("data-v-430a30f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "middle"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { "aria-label": "breadcrumb" }
const _hoisted_4 = { class: "breadcrumb" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = { class: "breadcrumb-item" }
const _hoisted_7 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_8 = { class: "description-tarif-group mb-5" }
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "description-tarif" }
const _hoisted_12 = { class: "description-tarif-head" }
const _hoisted_13 = { class: "group-logo-tarif" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", { class: "logo-image" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1))
const _hoisted_15 = { class: "data-tarif-item" }
const _hoisted_16 = { class: "gb-info-tarif" }
const _hoisted_17 = { class: "prise-tarif-sim-description" }
const _hoisted_18 = {
  key: 0,
  class: "exp error-text"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "esim-custom-label" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "esim-custom-label__title" }, "Label:", -1))
const _hoisted_22 = {
  key: 0,
  class: "description-usage"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "usage-text mb-0" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Usage")
], -1))
const _hoisted_24 = {
  key: 1,
  class: "usage-text"
}
const _hoisted_25 = { class: "sale-group" }
const _hoisted_26 = {
  key: 2,
  class: "description-tarif-middle"
}
const _hoisted_27 = {
  key: 3,
  class: "description-tarif-content"
}
const _hoisted_28 = { class: "tarif-content" }
const _hoisted_29 = { class: "activate-sim-manual__item" }
const _hoisted_30 = { class: "pin-code" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ICCID", -1))
const _hoisted_32 = { class: "tarif-content" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_35 = { class: "sidebar" }
const _hoisted_36 = { class: "by-moore-data" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Buy Another eSIM", -1))
const _hoisted_38 = {
  key: 1,
  class: "middle"
}

import {
  computed,
  ComputedRef,
  onMounted,
  ref,
  Ref,
  watch,
} from "vue";
import { Esim, EsimStatus, EsimType, useEsimStore } from "@/stores/esim";
import MainLoader from "@/components/MainLoader.vue";
import BundleCountries from "@/components/bundle/BundleCountries.vue";
import { Country, useDataStore } from "@/stores/data";
import { copyToClipBoard, dateToString } from "@/helpers";
import BundleSmallCard from "@/components/bundle/BundleSmallCard.vue";
import EsimActivation from "@/components/esim/EsimActivation.vue";
import PenIcon from "@/components/icons/PenIcon.vue";
import router from "@/router";

const esimLabelPlaceholder = "Name your eSim";


export default /*#__PURE__*/_defineComponent({
  __name: 'EsimDetails',
  props: {
  id: String,
},
  setup(__props) {

const esimStore = useEsimStore();
const dataStore = useDataStore();

const props = __props;
const esimId: ComputedRef<number> = computed(
  () => parseInt(props.id || "") || 0
);

const esim: ComputedRef<Esim | undefined> = computed(() =>
  esimStore.esims.find((esim: Esim) => esim.id === esimId.value)
);
const esimLoading: Ref<boolean> = ref(false);
const detailsOpened: Ref<boolean> = ref(false);
const termsOpened: Ref<boolean> = ref(false);
const esimLabelEditable: Ref<string> = ref("");
const esimCustomLabelInput = ref<HTMLInputElement>();

const esimLabel: ComputedRef<string | undefined> = computed(() =>
  esim.value ? esim.value.customLabel : undefined
);

async function getEsim(): Promise<void> {
  esimLoading.value = true;
  getLabelFromEsim();
  const response = await esimStore.getEsim(esimId.value);
  if (!response) {
    await router.push("/profile");
    return;
  }
  changeMeta();
  esimLoading.value = false;
  getLabelFromEsim();
}

function getLabelFromEsim(): void {
  esimLabelEditable.value =
    esimLabel.value && esimLabel.value.length
      ? esimLabel.value
      : esimLabelPlaceholder;
}

function saveLabel(): void {
  if (!esim.value) return;

  esimStore.setEsimLabel(esim.value.id, esimLabelEditable.value);
  esim.value.customLabel = esimLabelEditable.value;
}

watch(esimLabel, getLabelFromEsim);

onMounted(() => {
  getEsim();
});

function changeMeta(): void {
  const text = `eSIM: ${
    esim.value?.duration
  } days, ${esim.value?.dataAmountGb()} GB, ${esim.value
    ?.requestedCountries()
    .map((c) => c.name)
    .join(", ")} | Toosim`;
  document.title = text;
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", text);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (esim.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("nav", _hoisted_3, [
              _createElementVNode("ol", _hoisted_4, [
                _createElementVNode("li", _hoisted_5, [
                  _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [
                      _createTextVNode("eSIM Store")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_6, [
                  _createVNode(_component_router_link, { to: "/profile" }, {
                    default: _withCtx(() => [
                      _createTextVNode("my eSIMs")
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("li", _hoisted_7, _toDisplayString(esim.value.dataAmountGb()) + "gb " + _toDisplayString(esim.value.duration) + " days ", 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass(["col-lg-8", { 'col-lg-12': esim.value.status() === _unref(EsimStatus).newest }])
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createTextVNode(_toDisplayString(esim.value.dataAmountGb()) + " GB ", 1),
                            _createElementVNode("span", null, _toDisplayString(esim.value.duration) + " days", 1)
                          ]),
                          _createVNode(BundleCountries, {
                            countries: esim.value.bundleCountries(),
                            "requested-countries": esim.value.requestedCountries(),
                            "view-button": ""
                          }, null, 8, ["countries", "requested-countries"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["btn-new", {
                        active: esim.value?.status() === _unref(EsimStatus).active,
                        archive: esim.value?.status() === _unref(EsimStatus).archive,
                      }])
                        }, _toDisplayString(esim.value.status() === _unref(EsimStatus).active
                          ? "Active"
                          : esim.value.status() === _unref(EsimStatus).archive
                          ? "Archive"
                          : "New"), 3),
                        (
                        esim.value?.expireSoon() && esim.value?.type() !== _unref(EsimType).archive
                      )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Exp. soon (" + _toDisplayString(_unref(dateToString)(esim.value.expiresAt())) + ") ", 1))
                          : (esim.value?.activatedAt)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Expired at " + _toDisplayString(_unref(dateToString)(esim.value.expiresAt())), 1))
                            : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((esimLabelEditable).value = $event)),
                        class: _normalizeClass(["esim-custom-label__value", {
                      placeholdered: esimLabelEditable.value === esimLabelPlaceholder,
                    }]),
                        ref_key: "esimCustomLabelInput",
                        ref: esimCustomLabelInput,
                        placeholder: "Add label",
                        onFocus: _cache[1] || (_cache[1] = ($event: any) => (
                      esimLabelEditable.value === esimLabelPlaceholder
                        ? (esimLabelEditable.value = '')
                        : null
                    ))
                      }, null, 34), [
                        [_vModelText, esimLabelEditable.value]
                      ]),
                      (
                      (esimLabelEditable.value !== esim.value.customLabel &&
                        esimLabelEditable.value !== esimLabelPlaceholder) ||
                      esimLabelEditable.value === ''
                    )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "esim-custom-label__cancel",
                            onClick: getLabelFromEsim
                          }, " Cancel "))
                        : _createCommentVNode("", true),
                      (
                      (esimLabelEditable.value !== esim.value.customLabel &&
                        esimLabelEditable.value !== esimLabelPlaceholder) ||
                      esimLabelEditable.value === ''
                    )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "esim-custom-label__save",
                            onClick: saveLabel
                          }, " Save "))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "esim-custom-label__edit",
                            onClick: _cache[2] || (_cache[2] = () => esimCustomLabelInput.value.focus())
                          }, [
                            _createVNode(PenIcon, { class: "esim-custom-label__icon" })
                          ]))
                    ]),
                    (esim.value.status() === _unref(EsimStatus).active)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _hoisted_23,
                          (esimLoading.value)
                            ? (_openBlock(), _createBlock(MainLoader, {
                                key: 0,
                                class: "mb-2",
                                primary: "",
                                style: {"height":"20px"}
                              }))
                            : (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(esim.value.usedDataMb()) + " mb / " + _toDisplayString(esim.value.dataAmount) + " mb ", 1)),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("span", {
                              style: _normalizeStyle(`transition: 0.3s; width: ${
                        esimLoading.value
                          ? 0
                          : Math.round(
                              (esim.value.usedDataMb() / esim.value.dataAmount) * 100
                            )
                      }%`)
                            }, null, 4)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (esim.value.status() === _unref(EsimStatus).newest)
                      ? (_openBlock(), _createBlock(EsimActivation, {
                          key: 1,
                          esim: esim.value
                        }, null, 8, ["esim"]))
                      : _createCommentVNode("", true),
                    (esim.value.status() !== _unref(EsimStatus).newest)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26))
                      : _createCommentVNode("", true),
                    (esim.value.status() !== _unref(EsimStatus).newest)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["description-tarif-content-item", { active: detailsOpened.value }])
                          }, [
                            _createElementVNode("h6", {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (detailsOpened.value = !detailsOpened.value))
                            }, " eSIM details "),
                            _createElementVNode("div", _hoisted_28, [
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                  _hoisted_31,
                                  _createTextVNode(" " + _toDisplayString(esim.value.iccid), 1)
                                ]),
                                _createElementVNode("button", {
                                  class: "copy-btn",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(copyToClipBoard)(esim.value?.iccid || '')))
                                }, " Copy ")
                              ])
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["description-tarif-content-item", { active: termsOpened.value }])
                          }, [
                            _createElementVNode("h6", {
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (termsOpened.value = !termsOpened.value))
                            }, " Terms & Conditions "),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("p", {
                                innerHTML: _unref(dataStore).termsText
                              }, null, 8, _hoisted_33)
                            ])
                          ], 2)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                (esim.value.status() !== _unref(EsimStatus).newest)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("aside", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(esim.value.otherBundles, (b) => {
                              return (_openBlock(), _createBlock(BundleSmallCard, {
                                key: b.id,
                                bundle: b,
                                "requested-countries": esim.value.requestedCountries()
                              }, null, 8, ["bundle", "requested-countries"]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : (esimLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
            _createVNode(MainLoader, { primary: "" })
          ]))
        : _createCommentVNode("", true)
  ]))
}
}

})